var _path, _path2, _rect, _path3, _circle, _circle2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderSearchGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m125.215 119.747 12.298-59.942.002-.013a5.1 5.1 0 0 0-2.585-5.715 5.106 5.106 0 0 0-2.148-.582H95.17a32.811 32.811 0 0 0-.744-.75h38.38a5.853 5.853 0 0 1 5.44 7.217l-12.396 60.42-.635-.635Zm-17.945 2.198H18.46l12.977-63.28.002-.01a6.255 6.255 0 0 1 5.996-5.16h11.107a33.32 33.32 0 0 1 .744-.75H37.42a7.004 7.004 0 0 0-6.718 5.774l-13.07 63.726a.374.374 0 0 0 .368.45h90.02l-.75-.75Z",
    fill: "#1F323D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 122.32V27.68h30.3l5.86 10.26h64a4.63 4.63 0 0 1 4.63 4.63v6.75",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.622,
    y: 96.982,
    width: 40.121,
    height: 10.243,
    rx: 2,
    transform: "rotate(45 99.622 96.982)",
    fill: "#CDD9E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDD9E2",
    d: "m93.586 95.775 3.622 3.622-2.415 2.415-3.621-3.622z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.856,
    cy: 75.856,
    r: 29.929,
    transform: "rotate(45 71.856 75.856)",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.856,
    cy: 75.856,
    r: 23.166,
    transform: "rotate(45 71.856 75.856)",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.111 65.887a19.069 19.069 0 0 0-16.519-9.097",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSearchGrey);
export default __webpack_public_path__ + "static/media/folder_search_grey.6dd27cfc75dfa155e09d78aba197ee59.svg";
export { ForwardRef as ReactComponent };